export enum DataserviceHttpHeaders {
	X_DASHBOARD = 'X-Dashboard',
	X_REQUEST_COUNTER = 'X-Request-Counter',
	X_REQUEST_REALM = 'X-Request-Realm',
	X_RESTRICT_AUTHORIZATION = 'X-Restrict-Authorization',
}
